export default "__VITE_ASSET__Bu7x$YMT__"